import { useAuth } from '@/hooks/use-auth'
import { Loader2 } from 'lucide-react'
import { Navigate, Outlet } from 'react-router-dom'

export function ProtectedCoachRoute() {
  const { user, isLoading, isAuthenticated } = useAuth()

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (!user?.is_coach) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-2">Access Denied</h1>
          <p className="text-muted-foreground">You need coach privileges to access this portal.</p>
        </div>
      </div>
    )
  }

  return <Outlet />
}
